<template>
	<OverlayBackdrop v-if="display">
		<div :is="!parentTag ? 'div' : parentTag" class="flyout">
			<div class="flyout__header">
				<div class="flyout__header-txt">
					<span class="flyout__header-title"> {{ title }} </span>
					<span class="flyout__header-sub-heading">
						{{ subHeading }}
					</span>
				</div>
				<span class="flyout__header-close-btn">
					<Button
						ref="closeBtnRef"
						className="btn--icon-only"
						:btnClick="btnClose"
						:disabled="validateBeforeClose"
						:iconClassName="'icon-close'"
						:iconBeforeLabel="false"
					/>
				</span>
			</div>
			<div class="flyout__body" ref="flyoutBody" id="flyoutBody">
				<slot name="flyout-content"></slot>
			</div>
			<div class="flyout__footer">
				<slot name="flyout-footer">
					<ButtonGroup :items="buttons" v-if="buttons.length" />
				</slot>
			</div>
		</div>
	</OverlayBackdrop>
</template>

<script>
import Button from '@/components/forms/button/button';
import ButtonGroup from '@/components/forms/button/button-group';
import OverlayBackdrop from '@/components/visual/overlay-backdrop';

export default {
	name: 'Flyout',
	components: {
		Button,
		ButtonGroup,
		OverlayBackdrop
	},
	model: {
		prop: 'display',
		event: 'show'
	},
	props: {
		title: {
			type: String,
			default: ''
		},
		subHeading: {
			type: String,
			default: ''
		},
		parentTag: {
			type: String,
			default: 'div'
		},
		display: {
			type: Boolean,
			default: false
		},
		validateBeforeClose: {
			type: Boolean,
			default: false
		},
		buttons: {
			type: Array,
			default: () => []
		}
	},
	created() {
		const self = this;
		document.addEventListener('keyup', evt => {
			if (evt.key == 'Escape' && self.display) {
				self.btnClose();
			}
		});
	},
	methods: {
		btnClose(e) {
			if (e) {
				e.preventDefault();
			}
			if (!this.validateBeforeClose) {
				this.$emit('show', false);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * [Description]
    *
    * Global Flyout
    * Can use SCSS variables = TRUE
    *
    * All Flyout styles and variations are included here.
    *
    * [Table of Contents]
    *
		* Base............This section include the common styles for all screen sizes.
	*/

/*------------------------------------*\
  #BASE
\*------------------------------------*/
.flyout {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	position: fixed;
	top: 0;
	right: 0;
	width: 100%;
	max-width: 960px;
	height: 100vh;
	z-index: 100;
	padding: $padding-lg;
	background: $white;

	> * {
		width: 100%;
	}

	&__header {
		display: flex;
		justify-content: space-between;
		gap: $gutter-xl;
		align-items: flex-start;
		padding-bottom: $padding-sm;
		border-bottom: 1px solid $neutral-3;
		margin-bottom: $gutter-xl;
	}

	&__header-txt {
		display: flex;
		flex-direction: column;
	}

	&__header-title {
		@include heading('lg');
	}

	&__header-sub-heading {
		@include sub-heading;
	}

	&__body {
		overflow: auto;
		flex-grow: 2;
		@include body-text('regular');
	}

	&__footer {
		text-align: right;
		margin-top: $gutter-lg;
	}
}

/*------------------------------------*\
  #BASE TABLET PORTRAIT
\*------------------------------------*/
@include mq($from: md) {
	.flyout {
		width: auto;
		max-width: 60%;
	}
}

/*------------------------------------*\
  #BASE TABLET LANDSCAPE
\*------------------------------------*/
@include mq($from: md-l) {
	.flyout {
		max-width: 45%;
	}
}

/*------------------------------------*\
  #BASE DESKTOP
\*------------------------------------*/
@include mq($from: lg) {
	.flyout {
		max-width: 80%;
	}
}
</style>
